export class InfiniteScrolling {
    private static readonly threshold: number = 800;

    public onUpdate?: (page: number) => Promise<void>;

    private currentPage = 1;
    private nextPage = 2;
    private stopped = false;

    public register(): void {
        window.addEventListener('scroll', this.onScroll.bind(this));
    }

    private onScroll(): void {
        const scrollPosition = window.scrollY + window.innerHeight;
        const bodyHeight = document.body.clientHeight;

        if (scrollPosition < bodyHeight - InfiniteScrolling.threshold) {
            return;
        }

        this.trigger().catch((error): void => {
            throw error;
        });
    }

    private async trigger(): Promise<void> {
        if (this.stopped || this.currentPage === this.nextPage) {
            return;
        }

        try {
            this.currentPage = this.nextPage;
            const url = `${window.location}/page/${this.currentPage}`;

            if (!url) {
                return;
            }

            const response = await window.fetch(url);
            const text = await response.text();
            const parser = new DOMParser();
            const newDocument = parser.parseFromString(text, 'text/html');
            const wrapper = document.querySelector<HTMLElement>('.posts');
            const newWrapper = newDocument.querySelector<HTMLElement>('.posts');

            if (!wrapper || !newWrapper) {
                return;
            }

            const childs = newWrapper.children;

            for (const child of [ ...childs ]) {
                const clone = child.cloneNode(true);

                wrapper.appendChild(clone);
            }

            if (this.onUpdate) {
                await this.onUpdate(this.currentPage);
            }

            this.nextPage++;
        } catch (error) {
            this.stopped = true;
        }
    }
}
